import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "src/components/common";

export const SecurityPage: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Layout>
      <Box
        sx={{
          pt: "65px",
          m: "100px auto 200px",
          width: "1200px",
          maxWidth: "calc(100% - 250px)",
          color: "#323e59",
          [theme.breakpoints.down("md")]: { m: "60px 72px 120px", width: "auto", maxWidth: "none" },
          [theme.breakpoints.down("sm")]: { m: "60px 32px 120px" },
        }}
      >
        <Box mb="40px">
          <Typography
            sx={{
              fontSize: "clamp(20px,1.5vw,24px)",
              fontWeight: "500",
              letterSpacing: "0.03em",
              lineHeight: 2,
            }}
          >
            {t("security.sub_title")}
          </Typography>
          <Typography
            sx={{
              fontSize: "clamp(32px,4.125vw,66px)",
              fontWeight: "300",
              letterSpacing: "-0.07em",
              lineHeight: 1.4,
              mb: "20px",
            }}
          >
            {t("security.title")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "26px" }}>
          <Box>
            <Typography sx={{ m: "24px 0 42px", fontSize: "clamp(24px,3vw,32px)", fontWeight: "900" }}>
              {t("security.isms.title")}
            </Typography>
            <Typography sx={{ fontSize: "clamp(14px,1vw,16px)", fontWeight: "400", whiteSpace: "pre-wrap" }}>
              {t("security.isms.body")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default SecurityPage;
